import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import api from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2 } from "lucide-react";

export default function PaymentSuccess() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const [state, setState] = useState({ status: "checking", task_id: null });

  useEffect(() => {
    const sid = params.get("session_id");
    if (!sid) { setState({ status: "unknown" }); return; }
    let tries = 0;
    const tick = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sid}`);
        if (data.payment_status === "paid") {
          setState({ status: "paid", task_id: data.task_id });
          return;
        }
        if (tries++ < 15) setTimeout(tick, 2000);
        else setState({ status: "pending", task_id: data.task_id });
      } catch { setState({ status: "error" }); }
    };
    tick();
  }, [params]);

  return (
    <div className="max-w-lg mx-auto text-center py-16">
      <div className="w-16 h-16 rounded-full bg-emerald-100 grid place-items-center mx-auto">
        <CheckCircle2 size={32} className="text-emerald-600" />
      </div>
      <h1 className="font-heading text-3xl font-extrabold mt-6">
        {state.status === "paid" ? "Payment successful!" : state.status === "checking" ? "Confirming payment…" : "Payment status pending"}
      </h1>
      <p className="text-slate-600 mt-2">
        {state.status === "paid" ? "The helper has been notified. Please leave a rating." : "This can take a moment. Check back shortly."}
      </p>
      <div className="mt-8 flex justify-center gap-3">
        {state.task_id && (
          <Button onClick={() => navigate(`/tasks/${state.task_id}`)} data-testid="back-to-task-btn" className="bg-[#D9FF3D] hover:bg-[#C6EB2D] text-[#23272B] font-bold rounded-full">
            Back to task
          </Button>
        )}
        <Button variant="outline" onClick={() => navigate("/my-tasks")} className="rounded-full">My tasks</Button>
      </div>
    </div>
  );
}
